import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.736 11.332c-.82-.442-1.727-.959-2.15-1.27-.459-.347-.305-1.073.205-1.29l10.334-4.42c.666-.284 1.37.42 1.086 1.086l-4.42 10.32c-.216.51-.943.664-1.29.205-.659-.868-2.119-3.782-2.119-3.782L9.4 8.165" stroke="#fff" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>);